import _ from "lodash";
import swal from 'sweetalert';

export const timeZoneToLocationMap = {
   "Asia/Tokyo": "日本",
   "Asia/Ho_Chi_Minh": "ベトナム",
   "America/New_York": "アメリカ（ニューヨーク州）",
   "Asia/Bangkok": "タイ",
   "Asia/Shanghai": "中国",
};

export function getUserSort() {
  let userdata = {order: 'asc', orderBy: 'systemNo'};
  let item = localStorage.getItem('setting-user-sort');
  if (item && item !== 'undefined') {
      let setting = JSON.parse(item);
      if (setting && setting.order && setting.orderBy) {
          userdata = setting;
      }
  }
  return userdata;
}

export function descendingComparator(a, b, orderBy) {
  let valueA = a[orderBy];
  let valueB = b[orderBy];

  if (orderBy === 'time_zone') {
      valueA = timeZoneToLocationMap[a.time_zone] ?? '';
      valueB = timeZoneToLocationMap[b.time_zone] ?? '';
   }

  if (typeof valueA === 'string' && typeof valueB === 'string') {
    return valueB.localeCompare(valueA, undefined, {
      sensitivity: 'base',
      numeric: true
    });
  }

  if (valueB < valueA) {
    return -1;
  }
  if (valueB > valueA) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  if (array.length === 0){return [];}
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

// フィルターコンボボックスのデータ取得
export function getFilterOptions(items,keys,uniqItem,sortbyItem){
  if (items.length===0){return [];}
  let options= _.map(items,item => _.pick(item,keys));
  if (uniqItem){
    options=_.uniqBy(options, uniqItem);
  }
  if (sortbyItem){
    options=_.sortBy(options,sortbyItem);
  }
  return options;
};

export const validatePassword = (pass) => {
  const illegalChars = /^[a-zA-Z0-9!@#$%^&*+_-]+$/;

  if (pass === "") {
    swal({
      title: "設定エラー！",
      text: "パスワードを入力してください。",
      icon: "warning",
      buttons: "はい"
    });
    return false;
  } else if (illegalChars.test(pass) == false) {
    swal({
      title: "設定エラー！",
      text: "パスワードは4～16文字の半角英数字と一部の記号(! @ # $ % ^ & * + - _)を入力してください。",
      icon: "warning",
      buttons: "はい"
    });
    return false;
  } else if (pass.length < 4 || pass.length > 16) {
    swal({
      title: "設定エラー！",
      text: "パスワードは4～16文字の半角英数字と一部の記号(! @ # $ % ^ & * + - _)を入力してください。",
      icon: "warning",
      buttons: "はい"
    });
    return false;
  }

  return true;
};

export const fncisMailAddress = (mailAdd) => {
    var regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9.]{1,}$/;
    var res = mailAdd.split("@");
    if (mailAdd == "") {
        swal({
            title: "設定エラー！",
            text: "メールアドレスを入力してください。",
            icon: "warning",
            buttons: "はい"
        });
        return false;
    } else if ((res.length !== 2) || (mailAdd.length > 50) || (regexp.test(mailAdd) == false)) {
        var txtmess = "メールアドレスは、次の制限で入力してください。" +
    "\n●アルファベット（a-z）、数字（0-9）、「-」、「_」、「.」のみです。" +
    "\n●メールアドレス全体の文字数は50文字以内です。";
        swal({
            title: "設定エラー！",
            text: txtmess,
            icon: "warning",
            buttons: "はい"
        });
        return false;
    }
    return true;
}
